import * as React from 'react';
import { components } from 'react-select';

const ClearIndicator: React.SFC<any> = (props) => {
    return (
        <components.ClearIndicator {...props}>
            <i className="nx nx-close" />
        </components.ClearIndicator>
    );
};
export default ClearIndicator;
